import { memo, PropsWithChildren } from 'react';
import clsx from 'clsx';
import { SkeletonText } from '../SkeletonText/SkeletonText';
import { SkeletonButton } from '../SkeletonButton/SkeletonButton';

type Props = PropsWithChildren<{
    idle?: boolean;
    breadcrumbs?: boolean;
}>

export const SkeletonMainLayout = memo(({ idle, breadcrumbs = true, children }: Props) => (
    <div className="vss-skeleton-main-layout">
        <div className="vss-skeleton-main-layout__contents">
            <div className="vss-skeleton-main-layout__title">
                <SkeletonText idle={idle}/>
            </div>

            <div className="vss-skeleton-main-layout__controls">
                <SkeletonButton idle={idle} size="lg" className="vss-skeleton-main-layout__control"/>

                <SkeletonButton idle={idle} size="lg" className="vss-skeleton-main-layout__control"/>
            </div>

            {breadcrumbs && (
                <div className="vss-skeleton-main-layout__breadcrumbs">
                    <SkeletonButton fullSize={true} idle={idle}/>

                    <SkeletonButton fullSize={true} idle={idle}/>

                    <SkeletonButton fullSize={true} idle={idle}/>

                    <SkeletonButton fullSize={true} idle={idle}/>

                    <SkeletonButton fullSize={true} idle={idle}/>
                </div>
            )}

            <div className={clsx({
                'vss-skeleton-main-layout__body': true,
                'vss-skeleton-main-layout__body--with-breadcrumbs': breadcrumbs,
            })}
            >
                {children}
            </div>
        </div>
    </div>
));
